import { apiClient } from '@/shared/api/client';
import type { MorningSummaryResponse } from './types';

interface ApiResponse<T> {
  data: T;
  success: boolean;
}

export const morningSummaryApi = {
  /**
   * Get the 24h summary for a farm
   */
  getMorningSummary: async (farmId: string): Promise<MorningSummaryResponse> => {
    const response = await apiClient.get<ApiResponse<MorningSummaryResponse>>(
      `/farms/${farmId}/analytics/morning-summary`
    );
    return response.data.data;
  },
};
